import React from 'react';
import i18next from '../../config/i18next';

import {
  Button,
} from '../../components';

import './style.scss';

const NotFound = ({ entityStatus, entityType }) => {
  return (
    <div className="NotFound">
      {entityType === 'taxonomy_term' ? (
        <h1 className="page-header">
          {i18next.t('taxonomy_term_404')}
        </h1>
      ) : (
        <h1 className="page-header">
          {i18next.t('not_found')}{entityStatus || '503'}
        </h1>
      )}
      <p>{i18next.t('not_found_explanation')}</p>
      <Button primary withIcon buttonIcon href="/">
        {i18next.t('not_found_button')}
      </Button>
    </div>
  );
};

export default NotFound;
